/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import axios from "axios";
import Score from "../../components/Score/Score";
import PageButton from "../../components/PageButton/PageButton";
import Policies from "../../components/Policies/Policies";

//React Router
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

//React DatePicker Calendar
import DatePicker from "react-datepicker";
import "./react-datepicker.css";

//MUI Components
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

//React--Carousel-Minimal
import CarouselImages from "components/CarouselImages/CarouselImages";

//Styles
import "./product.scss";

//Assets
import gps from "../../assets/icons/gps.png";
import Gallery from "../../components/Gallery/Gallery";

const Product = () => {
  const { id } = useParams(); // Parametro de la url
  const [product, setProduct] = React.useState(null);

  //DatePicker States
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(null);
  const [occupation, setOccupation] = React.useState([]);
  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };
  //API CALL
  React.useEffect(() => {
    const fetchProduct = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/${id}`
        );
        setProduct(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchProduct();
  }, [id]);

  //API CALL
  React.useEffect(() => {
    const fetchOccupation = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/products/${id}/reservations`
        );

        const occupationData = resultado.data.map((reservation) => ({
          start: new Date(`${reservation.start_date.slice(0, 10)}T00:00:00Z`),
          end: new Date(`${reservation.end_date.slice(0, 10)}T12:00:00Z`),
        }));
        setOccupation(occupationData);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchOccupation();
  }, [id]);

  // Rezise Functions for the Carousel and the calendar
  const [size, setSize] = React.useState(window.innerWidth);

  React.useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return product ? (
    <>
      <div className="productPage__container">
        <div className="productPage__container__header">
          <div className="productPage__container__header__text">
            <p className="productPage__container__header__text__category">
              {product.category.title}
            </p>
            <p className="productPage__container__header__text__name">
              {product.title}
            </p>
          </div>
          <div className="productPage__container__header__icon">
            <Link to="/home">
              <ArrowBackIosIcon sx={{ fontSize: 40, color: "white" }} />
            </Link>
          </div>
        </div>
        <div className="productPage__container__topBar">
          <div className="productPage__container__topBar__address">
            <img width="15px" color="191b1d" src={gps} alt="gpsIcon" />
            <p>
              {product.location.city}, {product.location.country}
            </p>
          </div>
          <Score score={product.score} />
        </div>

        <section className="productPage__mainInfo">
          <div className="productPage__container__pictures">
            {size <= 900 ? (
              // <CarouselImages images={product.images} thumbnails={false} />
                <img
                    className="resultCard__image"
                    src='/car.webp'
                    alt={'Generic Card Image'}

                />
            ) : (
              // <Gallery images={product.images} />
              <img
              className="resultCard__image"
              src='/car.webp'
              alt={'Generic Card Image'}

              />
            )}
          </div>
          <div className="productPage__container__description">
            <h2>{product.description_title}</h2>
            <p className="productPage__container__description__text">
              {product.description}
            </p>
          </div>
        </section>
        <section className="productPage__container__features">
          <h2>¿Qué ofrece este vehículo?</h2>

          <div className="productPage__container__features__items">
            {product.features.map((feature) => (
              <div className="feature__item" key={feature.icon}>
                <img src={`/featureIcons/${feature.icon}.svg`} alt="" />
                <span>{feature.description}</span>
              </div>
            ))}
          </div>
        </section>

        <Policies />

        <section className="productPage__container__availableDates">
          <h2>Fechas disponibles</h2>

          <div className="productPage__container__reservation">
            <div className="productPage__container__reservation__calendar">
              <DatePicker
                selected={startDate}
                onChange={onChange}
                startDate={startDate}
                endDate={endDate}
                excludeDateIntervals={occupation}
                selectsRange
                monthsShown={size <= 745 ? 1 : 2}
                inline
                minDate={new Date()}
              />
            </div>
            <div className="productPage__container__reservation__button">
              <p>Agrega tus fechas de alquiler para obtener precios exactos</p>
              <Link
                className="productPage__container__reservation__submitButton"
                to={`/product/${product.id}/reservation`}
              >
                <PageButton filled label="Iniciar Reserva" />
              </Link>
            </div>
          </div>
        </section>

        <section className="productPage__container__location">
          <h2>¿Dónde vas a estar?</h2>
          {/*<p>*/}
          {/*  {product.address}, {product.location.city},{" "}*/}
          {/*  {product.location.country}*/}
          {/*</p>*/}
          <div className="productPage__container__location__map">
            <iframe
              // src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCc3zoz5TZaG3w2oF7IeR-fhxNXi8uywNk&zoom=16&q=place_id:${encodeURIComponent(
              //   product.maps_place_id
              // )}`}
              src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyCc3zoz5TZaG3w2oF7IeR-fhxNXi8uywNk&zoom=16&q=place_id:ChIJKcumLf2bP44RFDmjIFVjnSM`}
              width="100%"
              height="450"
              frameBorder="0"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>
      </div>
    </>
  ) : (
    <div className="productPage__container">
      <h2 className="product__loading">Loading data...</h2>
    </div>
  );
};

export default Product;
